{
  "title": "Desarrollador",
  "UI": {
    "title": "Interfaz de usuario"
  },
  "createDeviceActionSchedule": {
    "title": "Crear un programa de acciones del dispositivo"
  },
  "schedulesView": {
    "title": "Horarios"
  },
  "alertsDemo": {
    "alerts": "Alertas",
    "linkTo": "Demostración de alertas",
    "showTitleCheckbox": "Título",
    "title": "Demostración de alertas"
  },
  "buttonsDemo": {
    "actionButtons": "Botones de acción {{direction}}",
    "title": "Demostración de botones"
  },
  "devLanding": {
    "linkTo": "aterrizaje de desarrollo",
    "title": "Aterrizaje de desarrollo"
  },
  "fontDemo": {
    "italic": "Itálico",
    "linkTo": "demostración de fuente",
    "regular": "Regular",
    "subheader": "Título secundario",
    "title": "Demostración de fuente"
  },
  "linkTo": "Desarrollador",
  "scratch": {
    "linkTo": "rascar",
    "title": "Rascar"
  }
}
